



import { defineComponent, computed } from '@nuxtjs/composition-api';
import { SfBadge } from '@storefront-ui/vue';

export default defineComponent({
  name: 'PromotionBubble',
  components: {
    SfBadge
  },
  props: {
    small: { type: Boolean, default: false }
  },
  setup(props) {
    const sizeClass = computed(() => (props.small ? 'small' : 'large'));
    return {
      sizeClass
    };
  }
});
